import React from 'react';
import { Modal, Button, Steps } from '@douyinfe/semi-ui';
import { IconArrowRight, IconTick } from '@douyinfe/semi-icons';

//import steps
import Greetings from './Steps/Greetings';
import InitAdmin from './Steps/InitAdmin';
import DownloadInfobases from './Steps/DownloadInfobases';
import Finish from './Steps/Finish';
import InitDatabase from './Steps/InitDatabase';
import InitMailSystem from './Steps/InitMailSystem';
import InitStorageSystem from './Steps/InitStorageSystem';

const SetupTitles = ["Начало работы", "Инициализация базы", "Почтовая система", "Хранилище", "Администратор", "Загрузка БД", "Завершение"];

class SetupWizard extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            step: 0,
            nextDisabled: false
        };
        this.checkDisabledSetupNext = this.checkDisabledSetupNext.bind(this);
    }

    checkDisabledSetupNext = async(e) => {
        this.setState({nextDisabled: e});
    }

    render() {
        const { Step } = Steps;
        const currentStep = () => {
            switch (this.state.step) {
                case 0: return <Greetings />;
                case 1: return <InitDatabase check={this.checkDisabledSetupNext} toaster={this.props.toaster} />;
                case 2: return <InitMailSystem check={this.checkDisabledSetupNext} toaster={this.props.toaster} />;
                case 3: return <InitStorageSystem check={this.checkDisabledSetupNext} toaster={this.props.toaster} />;
                case 4: return <InitAdmin check={this.checkDisabledSetupNext} toaster={this.props.toaster} />;
                case 5: return <DownloadInfobases check={this.checkDisabledSetupNext} toaster={this.props.toaster} />;
                case 6: return <Finish check={this.checkDisabledSetupNext} />;
                default: return <Greetings />;
            }
        };

        const handleCloseClick = () => {
            this.props.openWizard(false)
        };

        const handleNextStepsClick = () => {
            if (this.state.step === SetupTitles.length - 1) {
                this.setState({ step: 0 });
                handleCloseClick();
                window.location.reload();
            } else {
                this.setState({ step: this.state.step + 1 });
            }
        };

        return (
            <Modal
                visible={this.props.openState}
                onCancel={handleCloseClick}
                fullScreen
                footer={
                    <Button
                        icon={this.state.step === SetupTitles.length - 1 ? <IconTick /> : <IconArrowRight />}
                        disabled={this.state.nextDisabled}
                        onClick={handleNextStepsClick}
                    >
                        {this.state.step === SetupTitles.length - 1 ? "Завершить установку" : "Далее"}
                    </Button>
                }
                bodyStyle={{display: 'flex', height: '100%'}}
            >
                <Steps current={this.state.step} direction="vertical" style={{ width: '270px', marginRight: '20px' }}>
                    {SetupTitles.map((title, index) => (
                        <Step key={index} title={title} />
                    ))}
                </Steps>
                <div style={{flexGrow: 'inherit', alignContent: 'center'}}>{currentStep()}</div>
            </Modal>
        );
    };
}

export default SetupWizard;